exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tag-item{background:#98a3a3;border-bottom:3px solid #7f8c8c;display:inline-block;font-size:19px;font-weight:400;line-height:30px;margin-bottom:37px;margin-right:20px;padding-left:11px;padding-right:13px;text-decoration:none;text-transform:uppercase}.tag-item,.tag-item:hover{border-radius:4px;color:#fff}.tag-item:hover{background:#e8645a;border-bottom:3px solid #e2534b}.tag-item.state-active{background:#62a29e;border-bottom:3px solid #528b86}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-949c599e","scoped":false,"hasInlineConfig":true}!./src/components/tag-item/tag-item.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-949c599e","scoped":false,"hasInlineConfig":true}!./src/components/tag-item/tag-item.css
// module chunks = index